export const psychePowers = [
    //dwarf
    {
        name: "1",
        description: `Modifier: 
        \nScore: After winning an attack or defense, you can restore health to that psyche score up to the amount you won by.`,
        aspect: "Passion",
        type: "power",
    },
    {
        name: "Manifest Self",
        description: `Modifier: Expend 1 point to use your Ego Modifier in place of another psyche roll. You must swap your ego score after the roll, and if you lose the roll, your ego takes double damage.
        \nScore: `,
        aspect: "Unity",
        type: "power",
    },
    {
        name: "2",
        description: `Modifier: Expend 1 point to delay any psyche damage until the end of your next turn, or ignore having to swap a psyche's active score.
        \nScore: You can redirect damage to your ego to your temperance score.`,
        aspect: "Temperance",
        type: "power",
    },
    //tanner
    {
        name: "3",
        description: `Modifier: Give an ally a +1d6 bonus to a psyche roll. Max once per ally per round. When your temperance score is at 0, you increase the bonus given by 1 per aspect you have cracked.
        \nScore: .`,
        aspect: "Passion",
        type: "power",
    },
    {
        name: "4",
        description: `Modifier: Expend one point to allow an ally use their modifier in place of another ally's modifier for a psyche roll. If the roll is still lost, both allies take the psyche damage.
        \nScore: `,
        aspect: "Unity",
        type: "power",
    },
    {
        name: "Blood Soaked Fire",
        description: `Modifier: Expend one point from your temperance pool to allow an ally to take damage for another ally.
        \nScore: You can take psyche damage for an ally as long as you are nearby them and can see them.`,
        aspect: "Temperance",
        type: "power",
    },
    //Chineka
    {
        name: "5",
        description: `Modifier: You can expend one point from your passion pool to gain +1d4 on an insight check into dangerous monsters or objects. Additionally, you can also choose for the insight check to be an action instead of instantaneous to increase the bonus to 1d6, and allow you to use your imagination modifier in place of the normal modifier. Doing this can cause unforseen side effects...  
        \nScore: You can expend points from your passion score to increase the result of an offensive roll. You must decide to do this before the results of the roll. After the attack, you take psyche damage equal to half of the expended amount to the attacking psyche score, and you must flip the aspect.`,
        aspect: "Passion",
        type: "power",
    },
    {
        name: "The Power Locked Away",
        description: `Modifier: You can expend a point from your unity to attempt to call out the entity sealed away in  
        \nScore: `,
        aspect: "Unity",
        type: "power",
    },
    {
        name: "6",
        description: `Modifier: Expend one temperance point to gain +1d6 on a defensive roll.
        \nScore: You can take damage here in place of an aspect that is using constitution as its active score.`,
        aspect: "Temperance",
        type: "power",
    },
    //Zhao
    {
        name: "7",
        description: `Modifier: You can expend one passion point during a psyche roll to roll a 1d4. On 4, you gain a +5 bonus to the roll, and you gain a +2 bonus on all rolls for 2 rounds. On a 1, you suffer a -2 penalty to the roll and any psyche damage resulting from the roll is also dealt to your temperance score.  
        \nScore: When you roll a natural 20 on a roll, you may expend points from your passion to increase the total result of the roll by up to twice the modifier of the roll. You must flip the aspect if you do this. If you roll a natural 1 during a roll, you can take damage to your temperance score in place of the normal psyche damage, you can swap the aspect's score after the damage.`,
        aspect: "Passion",
        type: "power",
    },
    {
        name: "8",
        description: `Modifier:   
        \nScore: `,
        aspect: "Unity",
        type: "power",
    },
    {
        name: "9",
        description: `Modifier: When rolling against a fear effect, you can expend one temperance point and 1 rage to negate the fear penalty and gain a +2 bonus on all rolls for 1d4 rounds If you roll a 4, the bonus increases to +3, if its a 1, you only gain a +1 bonus for 1 round.
        \nScore: `,
        aspect: "Temperance",
        type: "power",
    },
    //T'Richard
    {
        name: "10",
        description: `Modifier: You can expend one passion point during a psyche roll to roll a 1d4. On 4, you gain a +5 bonus to the roll, and you gain a +2 bonus on all rolls for 2 rounds. On a 1, you suffer a -2 penalty to the roll and any psyche damage resulting from the roll is also dealt to your temperance score.  
        \nScore: You can expend points from your passion score to increase the result of an offensive roll. You must decide to do this before the results of the roll. After the attack, you take psyche damage equal to half of the expended amount to the attacking psyche score, and you must flip the aspect.`,
        aspect: "Passion",
        type: "power",
    },
    {
        name: "The Power Locked Away",
        description: `Modifier: You can expend a point from your unity to attempt to call out the entity sealed away in  
        \nScore: `,
        aspect: "Unity",
        type: "power",
    },
    {
        name: "11",
        description: `Modifier: Expend one temperance point to gain +1d6 on a defensive roll.
        \nScore: You can take damage here in place of an aspect that is using constitution as its active score.`,
        aspect: "Temperance",
        type: "power",
    },
    //Eric
    {
        name: "12",
        description: `Modifier: Reduce damage an ally takes from an attack to 0. 
        \nScore: As an action, you can expend passion score to heal an adjacent ally's psyche scores.`,
        aspect: "Passion",
        type: "power",
    },
    {
        name: "Yeehaw!",
        description: `Modifier: Expend a unity point as an action to grant everyone a +3 on all rolls for 1 round.
        \nScore: You can swap health from one score to another.`,
        aspect: "Unity",
        type: "power",
    },
    {
        name: "13",
        description: `Modifier: Expend a temperance point to ignore the emotion aspect of an attack.
        \nScore: `,
        aspect: "Temperance",
        type: "power",
    },
]